import { render, staticRenderFns } from "./FeaturedStatistics.vue?vue&type=template&id=bc69d4fc&"
import script from "./FeaturedStatistics.vue?vue&type=script&lang=js&"
export * from "./FeaturedStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports